'use client';
import styled, { css } from 'styled-components';
import React from 'react';
import { theme } from '../../../theme';
import { createRichTextMarqueeBanner } from './richTextMarqueeBannerHelper';
import { COLOUR_SELECTION } from '../../../enums';

const ImageContainer = styled.div`
  max-height: 100px;
  min-height: 50px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-shrink: 0;
`;

const StyledImage = styled.img`
  min-height: 50px;
  width: 100%;
  height: auto;
`;

const MarqueeContainer = styled.div<{ $backgroundColour?: COLOUR_SELECTION }>`
  height: 40px;
  padding: ${theme.spacings[3].px} ${theme.spacings[4].px};
  ${theme.typography.body.xs}
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-shrink: 0;

  a.marqueeLink {
    color: inherit;
    text-decoration: underline;
  }

  ${({ $backgroundColour }) =>
    $backgroundColour === COLOUR_SELECTION.RED &&
    css`
      background-color: ${theme.colors.primary.graysRed};
      color: ${theme.colors.primary.white};
    `}

  ${({ $backgroundColour }) =>
    $backgroundColour === COLOUR_SELECTION.BLUE &&
    css`
      background-color: ${theme.colors.primary.graysBlue};
      color: ${theme.colors.primary.white};
    `}

  ${({ $backgroundColour }) =>
    $backgroundColour === COLOUR_SELECTION.GRAY &&
    css`
      background-color: ${theme.colors.primary.graysGray};
      color: ${theme.colors.primary.white};
    `}

  ${({ $backgroundColour }) =>
    !$backgroundColour &&
    css`
      background-color: ${theme.colors.primary.white};
      color: ${theme.colors.primary.graysGray};
    `}
`;

interface MarqueeBannerImage {
  url: string;
  width: number;
  height: number;
  description: string;
}

export interface MarqueeBannerProps {
  label: string;
  backgroundColour?: COLOUR_SELECTION;
  pictureMarquee?: MarqueeBannerImage;
  textMarquee?: string;
}

export const MarqueeBanner: React.FC<MarqueeBannerProps> = (data) => {
  if (!data.pictureMarquee) {
    return (
      <MarqueeContainer $backgroundColour={data.backgroundColour}>
        {createRichTextMarqueeBanner(data.textMarquee)}
      </MarqueeContainer>
    );
  }

  return (
    <ImageContainer>
      <StyledImage
        src={data.pictureMarquee.url}
        alt={data.pictureMarquee.description}
      />
    </ImageContainer>
  );
};
